import React from "react";
import clsx from "clsx";

import { makeStylesSeeded } from "@origin-digital/ods-core";
import { NavLinkIndentation } from "./NavLinkBase";

const useStyles = makeStylesSeeded(({ palette }) => ({
  navLinkContainer: {
    display: "flex",
    textDecoration: "none",
    alignItems: "center",
    width: "100%",
    paddingLeft: (paddingLeft) => `${paddingLeft}px`,

    "&:hover": {
      '&& [class*="MuiSvgIcon-root"], & > *': {
        color: palette.primary.main,
      },
    },
  },
}));

interface INavLinkContainer {
  children: React.ReactNode;
  id: string;
  href?: string;
  indent?: NavLinkIndentation;
}

export const NavLinkContainer = (props: INavLinkContainer) => {
  const { href, id, children, indent = NavLinkIndentation.None } = props;
  const styles = useStyles(indent);

  return href ? (
    <a
      href={href}
      data-id={id}
      id={id}
      className={clsx(styles.navLinkContainer)}
    >
      {children}
    </a>
  ) : (
    <span data-id={id} id={id} className={clsx(styles.navLinkContainer)}>
      {children}
    </span>
  );
};
